import { render } from "./IndexPanel.vue?vue&type=template&id=f9440d20&scoped=true&ts=true"
import script from "./IndexPanel.vue?vue&type=script&lang=ts"
export * from "./IndexPanel.vue?vue&type=script&lang=ts"

import "./IndexPanel.vue?vue&type=style&index=0&id=f9440d20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9440d20"]])

export default __exports__